// extracted by mini-css-extract-plugin
export var cookieTypes = "LegalsPage-module--cookieTypes--rQAuY";
export var legalsPage = "LegalsPage-module--legalsPage--yC08y";
export var type = "LegalsPage-module--type--f6IE8";